import { AbortedError, ProhibitActionError } from 'src/common/api/extended-emerald-error';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import XLRLogger from '../../common/helpers/logger';
import { IItemDetails } from '../../common/interfaces/dtos/IItemDetails';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { FORCE_QUANTITY_MODAL, showForceQuantityDialog } from '../force-quantity';
import { sellQuantityItem } from './sell-force-quantity-item';

const loggerSource = 'business-logic/handle-force-quantity.ts';

export const handleForceQuantityItemSale = async (
  lineItemData: ILineItemAddData,
  itemDetails: IItemDetails,
): Promise<void> => {
  const span = createSpan('handle-error-user-input');
  return new Promise<void>((resolve, reject) => {
    const onCancel = (): void => {
      endSpan(span);
      reject(new AbortedError());
    };
    const onSubmit = (quantity: string): void => {
      endSpan(span);
      if (quantity === '0') {
        popupMessage({ type: EmeraldDialogTypes.Error, message: 'InvalidQuantityKeyed' });
      } else {
        sellQuantityItem(Number(quantity), lineItemData)
          .then((): void => {
            XLRLogger.debug({
              message: 'Force Quantity Submitted Successfully',
              source: loggerSource,
            });
            resolve();
          })
          .catch(err => {
            if (err instanceof AbortedError || err instanceof ProhibitActionError) {
              reject(err);
            } else {
              popupMessage(err);
            }
          });
      }
    };

    XLRLogger.debug({ message: 'Force Quantity View', source: loggerSource });

    showForceQuantityDialog({ itemDetails, onCancel, onSubmit });
  }).finally(() => {
    popEmeraldModal(FORCE_QUANTITY_MODAL);
    XLRLogger.debug({
      message: 'Force Quantity View Closed',
      source: loggerSource,
    });
  });
};
